<template>
  <v-card class="mx-auto my-4" max-width="1000" :rounded="false" outlined>
    <v-toolbar color="blue-grey darken-1" dark flat>
      <v-checkbox v-model="selectAllRecords" dense hide-details color="blue-grey" @click.native="selectAll" />
      <v-toolbar-title>{{ localizedDatatype }}</v-toolbar-title>
      <v-spacer />
      <lean-list-query :datatype="datatype" class="mr-2" />
      <lean-limit-dropdown :datatype="datatype" class="mr-2" />
      <v-spacer />
      <lean-list-sort :datatype="datatype" />
      <lean-list-mode :datatype="datatype" />
      <lean-batch-publish :datatype="datatype" />
      <v-btn v-if="showCreateBtn" icon :to="'/data/' + datatype + '/_new'">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <div v-if="loading" class="text-center">
      <v-progress-circular class="my-10" indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <lean-list-items :records="items" :mode="listMode" :listConfig="listConfig" :datatype="datatype" />
    </div>
  </v-card>
</template>

<script>
import LeanListItems from '@/components/LeanListItems.vue';
import LeanLimitDropdown from '@/components/LeanLimitDropdown.vue';
import LeanListQuery from '@/components/LeanListQuery.vue';
import LeanListMode from '@/components/LeanListMode.vue';
import LeanListSort from '@/components/LeanListSort.vue';
import LeanBatchPublish from '@/components/LeanBatchPublish.vue';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'LeanList',
  components: {
    LeanBatchPublish,
    LeanListItems,
    LeanLimitDropdown,
    LeanListQuery,
    LeanListMode,
    LeanListSort
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    records: {
      type: Array,
      default: () => []
    },
    datatype: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      selectAllRecords: false
    };
  },
  computed: {
    ...mapState({
      datatypes: 'models',
      language: 'selectedLanguage'
    }),
    ...mapState('SelectedRecordListStore', { selectedRecordList: 'list' }),
    listMode() {
      return this.$store.state.AdminUserStore.listMode.find((item) => item.datatype === this.datatype)?.mode ?? 'list';
    },
    listConfig() {
      return this.datatypes[this.datatype].list || {};
    },
    localizedDatatype() {
      if (this.datatypes[this.datatype].title && this.datatypes[this.datatype].title[this.language]) {
        return this.datatypes[this.datatype].title[this.language];
      } else {
        return this.datatype;
      }
    },
    items() {
      return this.records.reduce((list, curr) => {
        if (curr.filename.indexOf(this.$store.state.search.toLowerCase()) > -1 && curr) {
          curr.data.slug = curr.slug;
          curr.resolved_data.slug = curr.slug;
          list.push(curr);
        }
        return list;
      }, []);
    },
    currentDatatype() {
      return this.datatypes[this.datatype];
    },
    showCreateBtn() {
      if (this.currentDatatype?.quantity && this.currentDatatype.quantity > this.items) return true;
      if (!this.currentDatatype?.quantity) return true;
      return false;
    }
  },
  methods: {
    ...mapMutations({
      clearSelectedRecords: 'SelectedRecordListStore/clear',
      addSlugToSelectedRecords: 'SelectedRecordListStore/addSlug'
    }),
    editItem(record) {
      const chunks = record.filename.split('/');
      this.$router.push({ path: `/data/${this.datatype}/${chunks[2]}` });
    },
    selectAll() {
      if (this.selectAllRecords) {
        this.records.forEach((item) => this.addSlugToSelectedRecords(item.slug));
      } else {
        this.clearSelectedRecords();
      }
    }
  },
  watch: {
    records: {
      handler() {
        this.clearSelectedRecords();
      },
      immediate: true
    },
    selectedRecordList: {
      handler(value) {
        this.selectAllRecords = this.records.length === value.length;
      }
    }
  }
};
</script>
